// Bold the spans of `text` that match `query` (case-insensitive, literal) — the
// "information scent" that shows *why* a row surfaced (F7/F8/F14).
export function highlightMatch(text: string, query: string) {
  const q = query.trim();
  if (!q) return text;
  const lower = text.toLowerCase();
  const target = q.toLowerCase();
  const parts: Array<{ text: string; match: boolean }> = [];
  let from = 0;
  let idx = lower.indexOf(target, from);
  while (idx !== -1) {
    if (idx > from) parts.push({ text: text.slice(from, idx), match: false });
    parts.push({ text: text.slice(idx, idx + target.length), match: true });
    from = idx + target.length;
    idx = lower.indexOf(target, from);
  }
  if (from < text.length) parts.push({ text: text.slice(from), match: false });
  return parts.map((part, i) =>
    part.match ? (
      <strong key={i} className="font-semibold text-foreground">
        {part.text}
      </strong>
    ) : (
      <span key={i}>{part.text}</span>
    ),
  );
}
